import { FragmentComponent } from '@/types/graphql'
import { DSGridBlock } from '@/components/ds/Grid/Grid'
import { DSText, DSFlex, DSSurfaceColorType, DSSurface } from '@zoe/ds-web'
import React from 'react'
import { processTypographyMarkdown } from '../DesignSystem/Typography'
import styled from 'styled-components'
import { CtaCollectionBlock, CtaCollectionRecord } from './CtaCollectionBlock'
import { ctaCollectionBlock } from '@/lib/api/graphql/utils/commonBlocks'

export type InfoSurfaceBlockRecord = {
  __typename: 'InfoSurfaceBlockRecord'
  id: string
  info: string
  surfaceColor?: DSSurfaceColorType
  ctaCollection?: CtaCollectionRecord
  dataTestId?: string
}

const fragment = `
  fragment InfoSurfaceBlockFragment on InfoSurfaceRecord {
    __typename
    id
    info
    surfaceColor
    ${ctaCollectionBlock}
    dataTestId
  }
`

const StyledSurface = styled.div`
  width: 100%;
  max-width: 1074px;
  margin: 0 auto;
`

export const InfoSurfaceBlock: FragmentComponent<{}, InfoSurfaceBlockRecord> = ({ record }) => {
  return (
    <DSGridBlock
      dataTestId={record?.dataTestId}
      padded
      breakConfig={{
        s: { colSpan: 2 },
        m: { colSpan: 6 },
        l: { colSpan: 10, offset: 1 },
        xl: { colSpan: 10, offset: 1 },
      }}
    >
      <StyledSurface>
        <DSSurface surfaceColor={record.surfaceColor || 'neutral'} radius={16} padding={24}>
          <DSFlex
            breakConfig={{
              maxViewportDirection: 'row',
              breakAt: {
                breakPoint: 'm',
                direction: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 16,
              },
            }}
            justifyContent="center"
            alignItems="center"
            gap={32}
          >
            <DSText
              as="p"
              variant="fluid-paragraph-300"
              weight="light"
              align="left"
              breakAt={{ breakPoint: 'm', variant: 'fluid-paragraph-200', align: 'center' }}
            >
              {processTypographyMarkdown({
                content: record.info,
                variant: 'fluid-paragraph-300',
                align: 'left',
                mobileVariant: 'fluid-paragraph-200',
                mobileAlign: 'center',
              })}
            </DSText>
            {record.ctaCollection && <CtaCollectionBlock record={record.ctaCollection} />}
          </DSFlex>
        </DSSurface>
      </StyledSurface>
    </DSGridBlock>
  )
}

InfoSurfaceBlock.fragment = fragment
InfoSurfaceBlock.recordName = 'InfoSurfaceSectionRecord'
